export interface UserSettings {
  settings_value: UserNotificationSetting;
  is_dnd?: boolean;
}

export interface UserNotificationSetting {
  shared_notes: boolean;
  record_visibility: boolean;
  deeproots: number;
  daily_unread_notifications_email: boolean;
  share_record_email: boolean;
  deeproots_matched_email: boolean;
}

export const DeepRootsModes = {
  ALL_SUBMISSIONS: 1,
  ONLY_MATCHES: 2,
};
